// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BjXD","left":"styles_left__2c7Jo"};